import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';



@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./dados-empresa-detalhar/dados-empresa-detalhar.module').then(m => m.DadosEmpresaDetalharModule) },
  ])],
  exports: [RouterModule]
})
export class DadosEmpresaRoutingModule { }
